<template>
  <div class="container">
    <div class="affix-container flex flex-column">
      <div class="affix-box curPointer flex flex-y-center flex-column" style="border-bottom: 1px dashed #cccccc;" @click="handleLeaveMessage">
        <img src="../assets/images/affix-1.png" alt="">
        <span>在线留言</span>
      </div>
      <el-popover
        placement="right"
        width="340"
        trigger="hover">
        <div class="flex flex-column flex-y-center tel-box">
          <div class="flex flex-y-center">
            <span class="tel-title">小院士</span>
            <span class="tel-num">187 6887 3612</span>
          </div>
          <div class="flex flex-y-center">
            <span class="tel-title">商学院</span>
            <span class="tel-num">135 9808 9524</span>
          </div>
          <div class="flex flex-y-center">
            <span class="tel-title">职业技术培训</span>
            <span class="tel-num">187 3682 1067</span>
          </div>
        </div>
        <div class="affix-box curPointer flex flex-y-center flex-column" slot="reference" style="border-bottom: 1px dashed #cccccc;">
          <img src="../assets/images/affix-2.png" alt="">
          <span>联系热线</span>
        </div>
      </el-popover>
      
      <el-popover
        placement="right"
        width="560"
        trigger="hover">
        <div class="flex flex-y-center space-between scan-code">
          <div class="scan-code-box flex flex-column flex-y-center">
            <img src="../assets/images/code-1.png" alt="">
            <span>职业技术培训</span>
          </div>
          <div class="scan-code-box flex flex-column flex-y-center">
            <img src="../assets/images/code-2.png" alt="">
            <span>小院士</span>
          </div>
          <div class="scan-code-box flex flex-column flex-y-center">
            <img src="../assets/images/code-3.png" alt="">
            <span>大河商学院</span>
          </div>
        </div>
        <div class="affix-box curPointer flex flex-y-center flex-column" slot="reference">
          <img src="../assets/images/affix-3.png" alt="">
          <span>扫码关注</span>
        </div>
      </el-popover>
      
    </div>
    <my-modal ref="myModal" :title="'反馈留言'"></my-modal>
  </div>
</template>

<script>
import myModal from '@/components/myModal.vue'
export default {
  components:{
    myModal
  },
  data () {
    return {
      dialogTableVisible: false,
      dialogFormVisible: false,
      form: {
        name: '',
      },
      formLabelWidth: '60px'
    }
  },
  watch:{
  },
  methods:{
    handleLeaveMessage(){
      this.$refs.myModal.isShow = true
    },
    // handleSubmit(){
    //   this.$message('提交成功');
    //   this.$refs.myModal.isShow = false
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@media screen and (max-width: 1400px) {
  .nav-container{
    min-width:1000px !important;
  }
}
.container{

  .content-box{
    width: 100%;  
    .content-info{
      // min-width: 1400px;
      // width: 1400px;
      margin: auto;
      .content-label{
        margin-bottom: 70px;
        &::after{
          content: "";
          width: 60px;
          height: 5px;
          background-color: #00AD60;
        }
        .content-label-text{
          font-size: 28px;
          font-weight: bold;
        }
        .content-label-value{
          display: block;
          font-size: 18px;
          margin: 15px 0;
        }
      }
    }
  }

  .affix-container{
    width: 90px;
    height: 310px;
    position: fixed;
    right: 0;
    top: 50%;
    background-color: #ffffff;
    box-shadow: 0px 4px 35px 0px rgba(0, 70, 5, 0.1);
    border-radius: 10px;
    z-index: 999;
    padding: 0 8px;
    .affix-box{
      padding: 20px 0;
      img{
        width: 36px;
        height: 36px;
        margin-bottom: 8px;
      }
      span{
        font-size: 14px;
      }
    }
  }
}

.tel-box{
  padding: 10px 0;
  >div{
    margin-bottom: 10px;
    .tel-title{
      width: 100px;
      text-align: left;
      font-size: 16px;
      margin-right: 10px;
    }
    .tel-num{
      font-size: 24px;
      font-weight: bold;
      color: #15A367;
    }
  }
  >div:last-child{
    margin-bottom: 0;
  }
}

.scan-code{
  padding: 10px;
  img{
    width: 144px;
    height: 144px;
    margin-bottom: 16px;
  }
  span{
    font-size: 16px;
  }
}

.dialog-footer{
  padding: 30px 0;
  button{
    width: 200px;
    height: 54px;
    font-size: 16px;
    color: #ffffff !important;
    background-image: linear-gradient(to right, #51d5c8  , #39d77a);
    border: none;
    border-radius: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/affix.vue